import { createContext, useContext, useState } from "react";
import JoinModal from "@/components/landing/JoinModal";

const JoinModalContext = createContext({ open: () => {} });

export const useJoinModal = () => useContext(JoinModalContext);

export default function JoinModalProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <JoinModalContext.Provider
            value={{ open: () => setIsOpen(true) }}
        >
            {children}
            <JoinModal open={isOpen} onOpenChange={setIsOpen} />
        </JoinModalContext.Provider>
    );
}
